import {gettext} from "../utils/translate";

export const WorkplaceTypes = {
    ZOS: 1,
    VLS: 2,
    IP: 3,
    DZS: 4,
    MEDICAL_FACILITY: 5,
    INSURANCE: 6,
    FR: 7,
    AG_TESTS_HOSPITALS: 8,
    AG_TESTS_EMS: 9,
    PATIENTS_REGISTER: 10,
    EDUCATION: 11,
    REFUGEES: 12,
}

export const WorkplaceTypesLabels = {
    1: gettext('Dispatching'),
    2: gettext('Chief Physician'),
    3: gettext('Inspector'),
    4: gettext('Transport Service'),
    5: gettext('Medical Facility'),
    6: gettext('Insurance'),
    7: gettext('First Responder'),
    8: gettext('Antigen Tests - Hospitals'),
    9: gettext('Antigen Tests - EMS'),
    10: gettext('Patients Register'),
    11: gettext('Education Department'),
    12: gettext('Refugees Register'),
}

export default class Workplace {
    id = null
    name = null
    type = null

    constructor(props = null) {
        if (props) {
            Object.assign(this, props);
        }
    }
}